import { render, staticRenderFns } from "./CellRendererActionNoteTemplate.vue?vue&type=template&id=2f4b2048&"
import script from "./CellRendererActionNoteTemplate.vue?vue&type=script&lang=js&"
export * from "./CellRendererActionNoteTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports